export default {
  state: {
    id: null,
  },
  getters: {
    isLoggedIn: state => !!state.id,
    customerId: state => state.id,
  },
  mutations: {
    setCustomerId(state, { id }) {
      state.id = id
    },
  },
}
